import {UserRole} from "@/shared/enums/UserRolesEnums";

import PerWeekList from "@/views/App/Analytics/UnitsDoneByExternalCoaches/Week/List.vue";
import PerMonthList from "@/views/App/Analytics/UnitsDoneByExternalCoaches/Month/List.vue";

const routesAnalyticsUnitsDoneByExternalCoaches = [
    {
        path: "units-done-by-external-coaches/week",
        name: "analyticsUnitsDoneByExternalCoachesPerWeek",
        component: PerWeekList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "units-done-by-external-coaches/month",
        name: "analyticsUnitsDoneByExternalCoachesPerMonth",
        component: PerMonthList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    }
]

export default routesAnalyticsUnitsDoneByExternalCoaches;